import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useTranslation } from '../../../../../../../shared/hooks';
import * as translations from '../../intl';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { Button } from '../../../../../../../components';

function JoinNow({
  videoId,
  gotTime,
  appointDateTime,
  onHandleStartVideoCall,
  status = '',
  onDetails = false,
}) {
  // Get translations
  const { locale: intl } = useTranslation({
    translationsFile: translations,
  });
  const { TITLE_APPOINTMENT_JOIN_NOW } = intl;

  const getTimeDiff = (start, end) => {
    return moment.duration(
      moment(end, 'HH:mm:ss a').diff(moment(start, 'HH:mm:ss a'))
    );
  };

  const shouldEnableJoinButton = useMemo(() => {
    // Parse appointment date/time
    const dateTime = moment(appointDateTime, 'YYYY-MM-DD HH:mm');
    const appointDate = moment(dateTime).format('YYYY-MM-DD');
    const appointTime = moment(dateTime).format('HH:mm');

    // Parse current server date/time
    const respDateTime = moment(gotTime, 'YYYY-MM-DD HH:mm');
    const respDate = moment(respDateTime).format('YYYY-MM-DD');
    const respTime = moment(respDateTime).format('HH:mm');

    // Calculate time difference
    const diff = getTimeDiff(respTime, appointTime);

    // Enable if on details page
    if (onDetails) {
      return true;
    }

    // Enable if same date and within 5 minutes of appointment time
    if (moment(respDate).isSame(appointDate) && diff.minutes() <= 5) {
      return true;
    }

    return false;
  }, [appointDateTime, gotTime, onDetails]);

  const renderContent = () => {
    if (onDetails) {
      return (
        <Button
          variant="contained"
          onClick={() => onHandleStartVideoCall(videoId)}
          startIcon={<VideocamOutlinedIcon />}
          text={TITLE_APPOINTMENT_JOIN_NOW}
          sx={{
            backgroundColor: '#e0e0e0',
            color: 'rgba(0,0,0,0.87)',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
            '&:hover': {
              backgroundColor: '#d5d5d5',
            },
          }}
        />
      );
    }

    if (shouldEnableJoinButton) {
      return (
        <Button
          color="primary"
          onClick={() => onHandleStartVideoCall(videoId)}
          startIcon={<VideocamOutlinedIcon />}
          text={TITLE_APPOINTMENT_JOIN_NOW}
        />
      );
    }
    return status;
  };

  return renderContent();
}

JoinNow.propTypes = {
  videoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  gotTime: PropTypes.string.isRequired,
  appointDateTime: PropTypes.string.isRequired,
  onHandleStartVideoCall: PropTypes.func.isRequired,
  status: PropTypes.string,
  onDetails: PropTypes.bool,
};

JoinNow.defaultProps = {
  status: '',
  onDetails: false,
};

export default memo(JoinNow);
